import {HttpClient, HttpParams} from '@angular/common/http';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {Component} from '@angular/core';
import {ParksFetcher} from '@app/app/shared/helpers/parks.fetcher';
import {WebHttpUrlEncodingCodec} from '@app/app/shared/helpers/web.http.url.encoding.codec';

@Component({
  selector: 'hardware-reports',
  styleUrls: ['../reports.css'],
  templateUrl: './reports.hardware.component.html'
})

export class ReportsHardwareComponent {
  public parks = [];
  public selectedPark1 = null;
  public selectedPark2 = null;
  public isLoadingResults = false;
  public chartOption = {};

  constructor(private http: HttpClient, private auth: AuthenticationService, private parksFetcher: ParksFetcher) {
    try {
      const parks = JSON.parse(sessionStorage.getItem('parks'));

      if (Array.isArray(parks) && parks.length > 0 && parks.length < 3) {
        this.selectedPark1 = parks[0];

        if (parks.length === 2) {
          this.selectedPark2 = parks[1];
        }
      }
    } catch (e) {
      console.log(e);
    }

    this.isLoadingResults = true;

    this.parksFetcher.retrieveParks().subscribe((res) => {
      this.parks = res;

      if (Array.isArray(this.parks) && this.parks.length > 0) {
        if (!this.selectedPark1) {
          this.selectedPark1 = this.parks[0].id;
        }

        this.reloadData();
      }
    }, (err) => {
      this.isLoadingResults = false;
    });
  }

  setPark1(value) {
    this.selectedPark1 = value;

    sessionStorage.setItem('parks', JSON.stringify([this.selectedPark1, this.selectedPark2].filter(p => p !== null && p !== '')));

    this.reloadData();
  }

  setPark2(value) {
    this.selectedPark2 = value;

    sessionStorage.setItem('parks', JSON.stringify([this.selectedPark1, this.selectedPark2].filter(p => p !== null && p !== '')));

    this.reloadData();
  }

  private prepareParams() {
    let params = new HttpParams({encoder: new WebHttpUrlEncodingCodec()})
      .set('type', 'on_state');

    if (this.selectedPark1) {
      params = params.append('parks[]', this.selectedPark1);
    }

    if (this.selectedPark2) {
      params = params.append('parks[]', this.selectedPark2);
    }

    return params;
  }

  private prepareCaption(id, date) {
    const parks = this.parks.filter(park => park.id === id);

    if (parks.length === 1) {
      return parks[0].attributes.name + ' - data since ' + date;
    }

    return 'N/A';
  }

  private processResult(result: any) {
    const dataLabels = result.labels;
    const legends = [];
    const series = [];

    Object.keys(result.values).forEach((id: any) => {
      const cap = this.prepareCaption(id, result.dates[id]);

      legends.push(cap);

      series.push({
        name: cap,
        type: 'bar',
        data: result.values[id].map((val:string) => parseFloat(val)),
        label: {
          show: true,
          rotate: 0,
          position: 'right',
          verticalAlign: 'middle',
          color: '#363636',
          formatter: (d) => d.data.toLocaleString(),
        }
      });
    });

    this.chartOption = {
      color: ['#4fc3f7', '#f74f8a'],
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        top: 20,
        data: legends
      },
      grid: {
        top: 60,
        left: 40,
        right: 60,
        bottom: 80,
        containLabel: true
      },
      toolbox: {
        show: false,
        orient: 'vertical',
        left: 'right',
        top: 'center',
        feature: {
          mark: {show: true},
          dataView: {show: true, readOnly: false},
          magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
          restore: {show: true},
          saveAsImage: {show: true}
        }
      },
      calculable: true,
      xAxis: [
        {
          type: 'value',
          name: 'Cumulative ON state in hours',
          nameLocation: 'middle',
          nameRotate: 0,
          nameGap: 40,
        }
      ],
      yAxis: [
        {
          type: 'category',
          data: dataLabels,
          axisLabel: {
            show: true,
            interval: 0,
            formatter: (val) => {
              if (val.length > 25) return val.substring(0, 24).trim() + "..."

              return val
            }
          }
        }
      ],
      series: series
    };
  }

  private reloadData() {
    this.isLoadingResults = true;

    this.http.get<any>('/reports/hardware', {params: this.prepareParams()}).subscribe((result) => {
      this.isLoadingResults = false;

      this.processResult(result);
    }, () => {
      this.isLoadingResults = false;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/hardware/reports.hardware.component.ts